import { createFileRoute } from '@tanstack/react-router'
import { LoginPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/login')({
  head: () => noIndexRouteHead('login', 'en'),
  component: LoginPage,
})
